import { render, staticRenderFns } from "./TrainingWatchEmployee.vue?vue&type=template&id=39b7ada5"
import script from "./TrainingWatchEmployee.vue?vue&type=script&lang=js"
export * from "./TrainingWatchEmployee.vue?vue&type=script&lang=js"
import style0 from "./TrainingWatchEmployee.vue?vue&type=style&index=0&id=39b7ada5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports